module.exports = __webpack_public_path__ + "static/img/btt2.673f1d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btt2.png
// module id = QC7a
// module chunks = 1